import { Component, OnInit, Inject, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { DeepConfigDialogComponent } from 'src/app/datasource/deep-config-dialog/deep-config-dialog.component';
import JSONFormatter from 'json-formatter-js';
import { ActionsCommonService } from '../actions-common.service';
import { CommonNotificationService } from 'src/app/shared/services/common-notification/common-notification.service';
import { DatacontextService } from 'src/app/data/datacontext.service';
import { UtilService } from 'src/app/shared/services/util/util.service';

@Component({
  selector: 'app-json-view-dialog',
  templateUrl: './json-view-dialog.component.html',
  styleUrls: ['./json-view-dialog.component.scss']
})
export class JsonViewDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  public jsonFormatter: any;
  public mode = 'view';
  public JSONValue;
  btnPromise: any;
  public isDeepConfigUpdated: boolean;
  deepConfigDialogRef: MatDialogRef<DeepConfigDialogComponent>;

  constructor(private el: ElementRef,
    private dialog: MatDialog,
    private actionsCommonService: ActionsCommonService,
    private datacontextService: DatacontextService,
    private commonNotificationService: CommonNotificationService,
    private dialogRef: MatDialogRef<JsonViewDialogComponent>,
    private utilService: UtilService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.utilService.hideScrollOnTopMostContainer();
  }

  ngOnDestroy() {
    this.utilService.removeHideScrollClassFromTopMostContainer();
  }

  ngAfterViewInit() {
    this.JSONValue = JSON.stringify(this.data.details.value, null, '\t');
    this.jsonFormatter = new JSONFormatter(this.data.details.value);
    this.el.nativeElement.querySelector('.json-container').appendChild(this.jsonFormatter.render());
  }

  /**
   * Opens Dialog to edit DC
   */
  openDeepConfigDialog(deepConfig) {
    this.isDeepConfigUpdated = false;
    this.deepConfigDialogRef = this.dialog.open(DeepConfigDialogComponent, {
      panelClass: 'dialog-side-panel',
      data: deepConfig,
      disableClose: true
    });
    this.deepConfigDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isDeepConfigUpdated = true;
        this.closeViewJSONDialog();
      }
    });
  }

  closeViewJSONDialog() {
    this.dialogRef.close(this.isDeepConfigUpdated ? { 'isDeepConfigUpdated': this.isDeepConfigUpdated } : null);
  }

  onUpdate() {
    const val = this.data;
    try {
      val.details.value = JSON.parse(this.JSONValue);
      const jsonSize: any = this.actionsCommonService.memorySizeOf(this.JSONValue);
      if (jsonSize > this.actionsCommonService.JSONMaxSize) {
        this.commonNotificationService.showSnackBar('Ensure that JSON is less than 20 KB. Please contact us to use a larger JSON', 'error');
        return;
      }
    } catch (e) {
      this.commonNotificationService.showSnackBar('Invalid JSON', 'error');
      return;
    }
    this.btnPromise = this.updateDeepConfig(val);
  }

  updateDeepConfig(val) {
    return this.datacontextService.datasource.updateDeepConfig(
      val.deepconfig_id,
      val.key,
      val.type,
      val.app_id,
      val.details,
      val.desc,
      val.is_active,
      val.module_id
    ).subscribe((data: any) => {
      if (data.is_error) {
        return;
      }

      const notificationMsg = 'Config "' + val.key + '" updated successfully';
      this.commonNotificationService.showSnackBar(notificationMsg, 'success');

      this.dialogRef.close(val);
    }, (err) => {
    });
  }

  editJson() {
    this.mode = 'edit';
  }

  viewJson() {
    this.mode = 'view';
  }
}
